import { Modal } from 'bootstrap';

const loadFile = ( id_file ) => {

	$( 'body' ).addClass( 'loading_file' );

	const data_action_file = {
		action: 'load_file',
		id_file,
	};
	$.post( themeVars.ajax_url, data_action_file, function( response ) {
		if (response) {
			const a = document.createElement( 'a' );
			a.href = response.url;
			a.target = '_blank';
			a.download = response.title;
			document.body.appendChild(a);
			a.click();
			
			a.remove();

			$( 'body' ).removeClass( 'loading_file' );
		}
	});
}

const loadForm = ( action ) => {
	const data = {
		action: 'load_form',
	};
	$.post( themeVars.ajax_url, data, function( response ) {
		if (response) {
			$( '#downloadModal .modal-body' ).empty().append( response );
			
			$( '#downloadModal form' ).attr( 'action', action );
		}
	});
}

/* eslint-disable */
const getCookieValue = (name) => {
	let cookie = {};
	document.cookie.split(';').forEach(function(el) {
		let [k,v] = el.split('=');
		cookie[k.trim()] = v;
	})
	return cookie[name];
};
/* eslint-enable */

export const dowmloadFileForm = () => {

	const downloadModal = document.querySelector('#downloadModal');

	if ( ! downloadModal ) return;

	const modal = new Modal(downloadModal);

	const action = $( '#downloadModal form' ).attr( 'action' );

	$( document ).on( 'click', '.js-modal-btn', function(e) {
		e.preventDefault();

		$( '.js-modal-btn' ).removeClass( 'active' );

		$( this ).addClass( 'active' );

		if ( getCookieValue( 'show_modal' ) ) {
			loadFile( $( '.js-modal-btn.active' ).data( 'file' ) );
		} else {
			modal.show();
		}
	});
	
	$( '#downloadModal' ).on( 'hidden.bs.modal', function() {
		$( '.js-modal-btn' ).removeClass( 'active' );

		$( '#downloadModal form, #downloadModal .gform_validation_errors' ).hide();

		// load form
		loadForm( action );
	});
	
	$( document ).on( "gform_confirmation_loaded", function () {
		// load file
		const id = $( '.js-modal-btn.active' ).data( 'file' );
		loadFile( id );

		$( '#downloadModal .btn-close' ).click();

		document.cookie = "show_modal=1; path=/";
	});

}



// WEBPACK FOOTER //
// ./scripts/modules/form-submision.js